// generated by bun run generate from the SwiftUI SDK and codegen/catalog.ts.
// edit the generator or catalog, then regenerate.
import type { ViewProps } from 'react-native';
import type { DirectEventHandler, Int32 } from 'react-native/Libraries/Types/CodegenTypes';
import codegenNativeComponent from 'react-native/Libraries/Utilities/codegenNativeComponent';
interface NativeProps extends ViewProps {
  label: string;
  systemImage: string;
  controlGroupStyle: string;
}
const NativeComponentRegistry = require('react-native/Libraries/NativeComponent/NativeComponentRegistry');
let nativeComponentName = 'OneNativeControlGroup';
export const __INTERNAL_VIEW_CONFIG = {
  uiViewClassName: "OneNativeControlGroup",
  validAttributes: {
    label: true,
    systemImage: true,
    controlGroupStyle: true
  }
};
export default NativeComponentRegistry.get(nativeComponentName, () => __INTERNAL_VIEW_CONFIG);